import { MouvementView } from "@features/stock/components/MouvementView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/mouvements/$id/view")({
  loader: requirePermission(PERMISSIONS.STOCK.MOVEMENTS.VIEW),
  component: ViewMouvementComponent,
});

function ViewMouvementComponent() {
  const { id } = Route.useParams();

  return <MouvementView id={Number(id)} />;
}
